import { render, staticRenderFns } from "./hokl_hosm_components.vue?vue&type=template&id=dbb60d0a&scoped=true"
import script from "./hokl_hosm_components.vue?vue&type=script&lang=js"
export * from "./hokl_hosm_components.vue?vue&type=script&lang=js"
import style0 from "./hokl_hosm_components.vue?vue&type=style&index=0&id=dbb60d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb60d0a",
  null
  
)

export default component.exports